import type { FC } from 'react'

import type { TIconProps } from 'types'

const SizeBarIcon: FC<TIconProps> = ({ className }) => (
  <svg className={className} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.6667 4.66667L9.66667 3.66667M8.66667 6.66667L7.66667 5.66667M6.66667 8.66667L5.66667 7.66667M4.66667 10.6667L3.66667 9.66667M11.3333 2L14 4.66667L4.66667 14L2 11.3333L11.3333 2Z'
      stroke='black'
      stroke-width='1.8'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)

export default SizeBarIcon
